import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../../environments/environment'
import { AppService } from 'src/app/server/app.service';

@Injectable()
export class InputSelectService {

    groupid: number
    selectid: number

    constructor(private http: HttpClient, private appService: AppService) { }

    getData(formData: string): Observable<any> {
        let httpParams = new HttpParams()
        Object.keys(formData).forEach(function (key) {
            httpParams = httpParams.append(key, formData[key])
        })

        return this.http.get<any>(`${environment.api}/${this.appService.session.groupid}/select/${this.selectid}`,
            {
                params: httpParams
            })

    }

}
